module.exports = __webpack_public_path__ + "img/fair-1.f84c4b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial/fair-1.png
// module id = 1190
// module chunks = 1